import { render, staticRenderFns } from "./payment-result-booking-card.vue?vue&type=template&id=07be2494&"
import script from "./payment-result-booking-card.vue?vue&type=script&lang=ts&"
export * from "./payment-result-booking-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports